var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarinline = function SvgCalendarinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A9A8A8",
    fillRule: "evenodd",
    d: "M13.125 2.617H.875A.875.875 0 0 0 0 3.492v10.5c0 .483.392.875.875.875h12.25a.875.875 0 0 0 .875-.875v-10.5a.875.875 0 0 0-.875-.875ZM1.75 13.117v-8.75h10.5v8.75H1.75Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9A8A8",
    d: "M3.5 8.742a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Zm3.5 0a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Zm4.375-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0ZM3.5 12.242a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Zm4.375-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0Zm2.625.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75ZM3.5.867a.875.875 0 0 0-.875.875v3.5a.875.875 0 1 0 1.75 0v-3.5A.875.875 0 0 0 3.5.867Zm7 0a.875.875 0 0 0-.875.875v3.5a.875.875 0 0 0 1.75 0v-3.5A.875.875 0 0 0 10.5.867Z"
  })));
};
export default SvgCalendarinline;